import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FaMapMarkerAlt } from "react-icons/fa";
import { RouteComponentProps } from "react-router";
import Card from "../../components/Card";
import Button from "../../components/Form/Button";
import Input from "../../components/Form/Input";
import ErroConsulta from "../../components/ErroConsulta";
import Loading from "../../components/Loading";
import PageHeader from "../../components/PageHeader";
import SubTitle from "../../components/SubTitle";
import Table from "../../components/Table";
import { useAuth } from "../../hooks/auth";
import { api } from "../../services/api";
import { semDadosNoProtheus } from "../../utils/consulta";
import { anos, meses } from "../../utils/datas";
import { getDateFromString } from "../../utils/date";
import { DateInfo } from "../ShareCapital/styles";

import { Container, Filters, InputGroup, Td } from "./styles";

interface MilkSupplyExtractProps {}

function MilkSupplyExtract({}: RouteComponentProps<MilkSupplyExtractProps>) {
  const { user } = useAuth();
  const { control, setValue, handleSubmit } = useForm();
  const [fazendas, setFazendas] = useState<any>({});
  const [loading, setLoading] = useState(true);
  // Mes com 2 digitos: o "0" fixo gerava "2026010" de outubro a dezembro,
  // e o Protheus recusa (ANOMES invalido)
  const [anomes, setAnomes] = useState(
    `${new Date().getFullYear()}${`${new Date().getMonth() + 1}`.padStart(2, "0")}`
  );
  const [consulta, setConsulta] = useState(0);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (!user.matricula) return;

    let cancelado = false;
    setLoading(true);
    setErro(false);
    api
      .get("getForLei", {
        params: {
          CODCLIENTE: user.matricula,
          ANOMES: anomes,
        },
      })
      .then((res: any) => {
        if (cancelado) return;
        let helper = {};
        res.data.forlei?.forEach((lei) => {
          if (helper[lei.fazenda]) {
            helper[lei.fazenda].push(lei);
          } else {
            helper[lei.fazenda] = [];
            helper[lei.fazenda].push(lei);
          }
        });
        setFazendas(helper);
      })
      .catch((error) => {
        if (cancelado) return;
        setFazendas({});
        setErro(!semDadosNoProtheus(error));
      })
      .finally(() => {
        if (!cancelado) setLoading(false);
      });

    return () => {
      cancelado = true;
    };
  }, [user.matricula, anomes, consulta]);

  function submitForm(form) {
    setAnomes(`${form.ano}${form.mes}`);
    setConsulta((c) => c + 1);
  }

  return (
    <Container>
      <PageHeader title="Extrato For. Leite"/>

      <Filters>
        <InputGroup>
          <Input control={control} type="select" values={meses} name="mes" placeholder="Mês" />
        </InputGroup>
        <InputGroup>
          <Input control={control} type="select" values={anos} name="ano" placeholder="Ano" />
        </InputGroup>
        <InputGroup>
          <Button onClick={handleSubmit(submitForm)}>CONSULTAR</Button>
        </InputGroup>
      </Filters>
      {loading ? (
        <Loading />
      ) : erro ? (
        <ErroConsulta onTentarNovamente={() => setConsulta((c) => c + 1)} />
      ) : (
        <>
          {Object.entries(fazendas).map(([key, value]: any) => {
            let total = 0;
            return (
              <>
                <SubTitle text={key} icon={FaMapMarkerAlt} />
                <Card>
                  <DateInfo>Emitido em: {new Date().toLocaleString()}</DateInfo>
                  <Container className="div-table">
                  <Table>
                    <tr>
                      <th>Data</th>
                      <th>Água</th>
                      <th>Crioscop</th>
                      <th>Quantidade</th>
                      <th>Temperatura</th>
                    </tr>
                    {value.map((info) => {
                      total += info.leite;
                      return (
                        <tr>
                          <td>
                            {getDateFromString(info.datacoleta).toLocaleString(
                              "default",
                              {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                              }
                            )}
                          </td>
                          <td>{info.agua}</td>
                          <td>{info.crioscop}</td>
                          <td>{info.leite}</td>
                          <td>{info.temperatura}</td>
                        </tr>
                      );
                    })}
                    <tr  className="bgBlue">
                      <Td colSpan={11} className="bgBlue">
                        <b>Total: {+total.toFixed(2)}</b>
                      </Td>
                    </tr>
                  </Table>
                  </Container>
                  
                </Card>
              </>
            );
          })}
          {!Object.entries(fazendas).length && <SubTitle text="Nenhum dado encontrado para essa data." icon={FaMapMarkerAlt} />}
        </>
      )}
    </Container>
  );
}

export default MilkSupplyExtract;
